import { lessonPlanRoutes } from "./lessonPlans"

export const SYLLABUS_TOPIC_PARAM = "tema"
export const GENERATION_PARAM = "crear"

export const classroomPlanningRoutes = {
  syllabusPattern: "/salones/:classroomId/temario",
  syllabus: (classroomId: string) => `/salones/${classroomId}/temario`,
  notes: (classroomId: string) => `/salones/${classroomId}/notas`,
}

export function planningGenerationPath(
  classroomId: string,
  kind: "notes" | "lesson",
  topicIds: string[],
) {
  const params = new URLSearchParams({ [GENERATION_PARAM]: "1" })
  for (const id of topicIds) params.append(SYLLABUS_TOPIC_PARAM, id)
  const path =
    kind === "notes"
      ? classroomPlanningRoutes.notes(classroomId)
      : lessonPlanRoutes.workspace(classroomId)
  return `${path}?${params}`
}
